import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/ui/header'
import { SearchForm } from '@/components/widgets/search-form'
import { getIntercoms } from '@/api/get-intercoms'

export const Route = createFileRoute('/')({
  component: HomePage,
  loader: getIntercoms,
  staleTime: Infinity,
})

function HomePage() {
  return (
    <>
      <Header title={'Оплата услуг домофона'} />
      <SearchForm />
    </>
  )
}
